module.exports = __webpack_public_path__ + "static/media/customer-whole-earth.a9638aa3.png";